import { Highlight } from "react-instantsearch-hooks-web";
import { formatPrice } from "../utils/formatPrice";

export const Item = ({ hit }) => (
  <div className="">
    <a
      href={hit.url}
      className="block w-full sm:h-[300px] rounded overflow-hidden"
    >
      <img
        className="w-full sm:h-[300px] object-cover"
        src={hit.photo}
        alt={hit.name}
        loading="lazy"
      />
    </a>
    <div className="">
      <div className="woo-product-category text-gray-400 pt-2 pb-1">
        <Highlight hit={hit} attribute="category.lvl1" />
      </div>
      <a href={hit.url}>
        <h2 className="transition-all duration-150 woocommerce-loop-product__title text-lg hover:text-[#dd2c2c] pb-1">
          <Highlight hit={hit} attribute="name" />
        </h2>
      </a>
      <p className="price wooviews-product-price">
        {formatPrice(hit.priceMin, hit.priceMax)}
      </p>
    </div>
  </div>
);
